<template>
  <div class="video-page">
    <Header :title="showLang[selectLang]['views']['Video']['page_name']" @childLang="useLang" @toggleSidebar="$emit('toggleSidebar')"/>
    <main class="video-main">
      <div class="video-content">
        <div class="video-grid">
          <div class="player-section">
            <div class="player-card">
              <YouTube
                :src="defaultPlay"
                width="100%"
                height="480"
                @ready="onReady"
                ref="youtube"
                :vars="vars"
              />

              <div class="player-body">
                <div class="chapters">
                  <div class="chapter-label">章節</div>
                  <div
                    class="chapter"
                    v-for="(paragraphItem, paragraphIndex) in defaultParagraph"
                    :key="paragraphIndex"
                    @click="toParagraph('', defaultPlay, paragraphItem.start)"
                  >
                    <span class="chapter-time">{{paragraphItem.time}}</span>
                    <span class="chapter-text">{{paragraphItem.text}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="list-section">
            <div class="list-scroll">
              <div
                class="list-card"
                :class="{ 'border-blue-600': checked }"
                v-for="(item, index) in videoData"
                :key="index"
                @mouseover="item.playStatus = true"
                @mouseleave="item.playStatus = false"
              >
                <div class="list-card-inner">
                  <div
                    class="list-thumb-wrap"
                    @click="toVideo(item.title, item.src, item.paragraph)"
                  >
                    <div v-if="item.playStatus" class="list-thumb-overlay" style="width: 128px; height:128px;"></div>
                    <img class="list-thumb" :src="item.img" />
                  </div>
                  <div class="list-info">
                    <p class="list-name">{{item.title}}</p>
                    <p v-html="item.describe" class="list-desc"></p>
                  </div>

                  <div
                    v-if="item.playStatus"
                    class="list-play-btn"
                    style="left:3rem;"
                    @click="toVideo(item.title, item.src, item.paragraph)"
                  >
                    <img src="https://private.autoturn.net/img/play.png" style="width: 40px;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </main>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { createApp, ref, watch } from 'vue'
  import Header from '@/components/Header.vue'
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import axios from 'axios'
  import Qs from 'qs'
  import lang from '@/language/lang.json'

  export default {
    name: 'Home',
    components: {
      Header,
      Loading
    },
    props: {

    },
    data() {
      return {
        showVideoModal: false,
        selectLang: 'zh-TW',
        showLang: lang,
        videoData: {
          title: '',
          src: '',
          itmeSrc: ''
        },
        defaultPlay: 'https://youtu.be/xnmcnB04vTM',
        defaultParagraph:[
          { time: '0:00', text: '如何新增廣告帳號與粉絲專頁', start: 0},
          { time: '0:41', text: '如何新增沒有在列表上的粉絲專頁', start: 41},
          { time: '1:26', text: 'AutoTurn訂閱方案', start: 86},
        ],
        vars: {
          rel: 0,
          start: 0,
        },
        videoData:[
          {
            title: 'AutoTurn 帳號資訊頁',
            describe: '將為您說明如何新增廣告帳號與粉絲專頁，以及訂閱方案說明',
            img: 'https://private.autoturn.net/img/youtube_01.png',
            src: 'https://youtu.be/xnmcnB04vTM',
            playStatus: false,
            paragraph: [
              { time: '0:00', text: '如何新增廣告帳號與粉絲專頁', start: 0},
              { time: '0:41', text: '如何新增沒有在列表上的粉絲專頁', start: 41},
              { time: '1:26', text: 'AutoTurn訂閱方案', start: 86},
            ]
          },
          {
            title: 'AutoTurn 使用第一步 建立一個行銷活動',
            describe: '將為您說明行銷活動名稱、行銷方式、行銷日期的相關設定',
            img: 'https://private.autoturn.net/img/youtube_02.png',
            src: 'https://youtu.be/VMMjP-UF6BY',
            playStatus: false,
            paragraph: [
              { time: '0:00', text: '開頭', start: 0},
              { time: '0:06', text: '開始說明', start: 6},
              { time: '0:26', text: '行銷方式介紹-精準興趣', start: 26},
              { time: '0:34', text: '行銷方式介紹-年齡性別', start: 34},
              { time: '0:59', text: '行銷方式介紹-類似受眾', start: 59},
              { time: '1:28', text: '行銷方式介紹-再行銷', start: 88},
              { time: '2:13', text: '輸入預計分析或推廣網址', start: 133},
              { time: '3:59', text: '行銷日期設定', start: 239},
            ]
          },
          {
            title: 'AutoTurn 使用第二步 設定廣告目標與受眾資料',
            describe: '將為您說明行銷活動目標設定、地點語言個人設定、關鍵鏈與受眾的相關設定',
            img: 'https://private.autoturn.net/img/youtube_03.png',
            src: 'https://youtu.be/6vD-2v5RWyk',
            playStatus: false,
            paragraph: [
              { time: '0:00', text: '行銷活動目標設定', start: 0},
              { time: '0:41', text: '目標成本設定', start: 41},
              { time: '1:31', text: '預算使用設定', start: 91},
              { time: '2:58', text: '預算比率設定', start: 178},
              { time: '3:47', text: '地點語言個人設定', start: 227},
              { time: '4:19', text: '關係鏈與受眾設定', start: 259},
            ]
          },
          {
            title: 'AutoTurn 使用第三步 建立廣告素材與發佈',
            describe: '將為您說明版位與裝置、身份、廣告素材內容等相關設定',
            img: 'https://private.autoturn.net/img/youtube_04.png',
            src: 'https://youtu.be/3wGiBNSfa8E',
            playStatus: false,
            paragraph: [
              { time: '0:00', text: '版位與裝置', start: 0},
              { time: '0:13', text: '版位裡的Audience Network是什麼', start: 13},
              { time: '0:16', text: '身份設定', start: 16},
              { time: '0:24', text: '廣告素材內容 ', start: 24},
              { time: '0:30', text: '建立廣告貼文', start: 30},
              { time: '0:54', text: '選擇現有貼文', start: 54},
              { time: '1:13', text: '如何搜尋不在粉絲專頁的廣告素材', start: 73},
              { time: '1:30', text: '如何找廣告的貼文編號', start: 90},
              { time: '2:54', text: '發佈廣告前的最後確認', start: 174},
              { time: '3:26', text: '發布成功後，至FB廣告管理員確認', start: 206},
              { time: '4:07', text: 'AI投遞廣告的邏輯', start: 247},
            ]
          },
          {
            title: 'AutoTurn 觀看分析報表（AutoTurn專屬分析報表）',
            describe: '將為您說明分析報表的功能',
            img: 'https://private.autoturn.net/img/youtube_05.png',
            src: 'https://youtu.be/L1VnIeaHB6o',
            playStatus: false,
            paragraph: [
              { time: '0:00', text: '如何看分析報表', start: 0},
              { time: '0:23', text: '如何看精準興趣關鍵字', start: 23},
            ]
          },
          {
            title: 'Autorun-素材最佳化在做什麼？',
            describe: '將為您說明素材最佳化的用途。',
            img: 'https://private.autoturn.net/img/youtube_06.png',
            src: 'https://youtu.be/ZVlnP5DHRkc',
            playStatus: false,
            paragraph: []
          },
          {
            title: 'Autoturn-轉換廣告發不過（Ｘ）跳出必須提供轉換網域怎麼辦？',
            describe: '將為您說明轉換網域的相關設定。',
            img: 'https://private.autoturn.net/img/youtube_07.png',
            src: 'https://youtu.be/gugDShMcvk0',
            playStatus: false,
            paragraph: []
          },
          {
            title: 'Autoturn-怎麼建立私訊類型廣告',
            describe: '將為您說明如何設定私訊廣告。',
            img: 'https://private.autoturn.net/img/youtube_08.png',
            src: 'https://youtu.be/7heZPoatE-Q',
            playStatus: false,
            paragraph: []
          },
          {
            title: 'Autoturn-怎麼建立收名單廣告',
            describe: '將為您說明如何設定收名單廣告。',
            img: 'https://private.autoturn.net/img/youtube_09.png',
            src: 'https://youtu.be/ro54Sk19y4Y',
            playStatus: false,
            paragraph: []
          },
          {
            title: 'Autoturn-如果登入連接帳號看不到粉絲專頁或廣告帳號時，怎麼辦？',
            describe: '將為您說明如何處理粉絲專頁或廣告帳號的相關問題。',
            img: 'https://private.autoturn.net/img/youtube_10.png',
            src: 'https://youtu.be/si9M_0SU_fo',
            playStatus: false,
            paragraph: []
          },
          {
            title: 'Autoturn-目錄銷售廣告建立',
            describe: '將為您說明如何建立目錄銷售廣告。',
            img: 'https://private.autoturn.net/img/youtube_11.png',
            src: 'https://youtu.be/QExfvzbYDFE',
            playStatus: false,
            paragraph: []
          },
          {
            title: 'Autoturn-名單廣告投放後，要怎麼下載名單？',
            describe: '將為您說明如何下載名單。',
            img: 'https://private.autoturn.net/img/youtube_12.png',
            src: 'https://youtu.be/3AbSt43rhUE',
            playStatus: false,
            paragraph: []
          },
          {
            title: 'Autoturn-怎麼上傳素材',
            describe: '將為您說明如何上傳素材。',
            img: 'https://private.autoturn.net/img/youtube_13.png',
            src: 'https://youtu.be/03BQP5UZqlI',
            playStatus: false,
            paragraph: []
          },
        ]
      }
    },
    created() {
      let hash = this.$route.params.id;

      if(hash != '' && hash != null && typeof hash != 'undefined'){
         axios
          .post('https://www.autoturn.net/api/get_lang.php', Qs.stringify({
            s_code: this.$route.params.id
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.selectLang = response.data.return_data

              axios
                .post('https://www.autoturn.net/api/login.php', Qs.stringify({
                  s_code: this.$route.params.id
                }), {withCredentials: true})
                .then((response) => {
                  if(response.data.status == 'success'){

                  }

                  if(response.data.status == 'error'){
                    // console.log('home logout');
                    // window.location.href = "https://ci.local/_autoturn_local_inside/index.php/login/view";
                    Swal.fire({
                      icon: 'error',
                      title: this.showLang[this.selectLang]['views']['Video']['axios']['login_error_title'],
                      text: response.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['Video']['axios']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      /* Read more about isConfirmed, isDenied below */
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        // this.allPageLoading = true
                        window.location.href = "https://www.autoturn.net/index.php/index/logout/"+hash+"?o=1";
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        // this.allPageLoading = true
                        window.location.href = "https://www.autoturn.net/index.php/index/logout/"+hash+"?o=1";
                      }
                    })
                  }

                  if(response.data.status == 'login'){
                    Swal.fire({
                      icon: 'error',
                      title: this.showLang[this.selectLang]['views']['Video']['axios']['login_error_title'],
                      text: response.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['Video']['axios']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      /* Read more about isConfirmed, isDenied below */
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        // this.allPageLoading = true
                        window.location.href = "https://www.autoturn.net/index.php/index/logout/"+hash+"?o=1";
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        // this.allPageLoading = true
                        window.location.href = "https://www.autoturn.net/index.php/index/logout/"+hash+"?o=1";
                      }
                    })
                  }
                });
            } else {
              Swal.fire({
                icon: 'error',
                title: this.showLang[this.selectLang]['views']['Video']['axios']['swal_title'],
                text: response.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['Video']['axios']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  this.allPageLoading = true
                  window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  this.allPageLoading = true
                  window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                }
              })
            }
          });

      } else {
        Swal.fire({
          icon: 'error',
          title: this.showLang[this.selectLang]['views']['Video']['axios']['login_empty_title'],
          text: this.showLang[this.selectLang]['views']['Video']['axios']['login_empty_info_text'],
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: this.showLang[this.selectLang]['views']['Video']['axios']['confirm_button']
          // denyButtonText: `Don't save`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            // Swal.fire('Saved!', '', 'success')
            // this.allPageLoading = true
            window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
          } else if (result.isDenied) {
            // Swal.fire('Changes are not saved', '', 'info')
            // this.allPageLoading = true
            window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
          }
        })
      }
    },
    methods: {
      useLang(v){
        if(v == '' || v == null || typeof v == 'undefined'){
          v = 'zh-TW';
        }

        this.selectLang = v
        this.$emit('childLang', v);

        document.title = this.showLang[this.selectLang]['views']['Video']['page_name']+' - AutoTurn';

        this.defaultParagraph = [
          { time: '0:00', text: this.showLang[v]['views']['Video']['base_video']['part01'], start: 0},
          { time: '0:41', text: this.showLang[v]['views']['Video']['base_video']['part02'], start: 41},
          { time: '1:26', text: this.showLang[v]['views']['Video']['base_video']['part03'], start: 86},
        ];

        this.videoData = [
          {
            title: this.showLang[v]['views']['Video']['list_01_video']['title'],
            describe: this.showLang[v]['views']['Video']['list_01_video']['describe'],
            img: 'https://private.autoturn.net/img/youtube_01.png',
            src: 'https://youtu.be/xnmcnB04vTM',
            playStatus: false,
            paragraph: [
              { time: '0:00', text: this.showLang[v]['views']['Video']['list_01_video']['part01'], start: 0},
              { time: '0:41', text: this.showLang[v]['views']['Video']['list_01_video']['part02'], start: 41},
              { time: '1:26', text: this.showLang[v]['views']['Video']['list_01_video']['part03'], start: 86},
            ]
          },
          {
            title: this.showLang[v]['views']['Video']['list_02_video']['title'],
            describe: this.showLang[v]['views']['Video']['list_02_video']['describe'],
            img: 'https://private.autoturn.net/img/youtube_02.png',
            src: 'https://youtu.be/VMMjP-UF6BY',
            playStatus: false,
            paragraph: [
              { time: '0:00', text: this.showLang[v]['views']['Video']['list_02_video']['part01'], start: 0},
              { time: '0:06', text: this.showLang[v]['views']['Video']['list_02_video']['part02'], start: 6},
              { time: '0:26', text: this.showLang[v]['views']['Video']['list_02_video']['part03'], start: 26},
              { time: '0:34', text: this.showLang[v]['views']['Video']['list_02_video']['part04'], start: 34},
              { time: '0:59', text: this.showLang[v]['views']['Video']['list_02_video']['part05'], start: 59},
              { time: '1:28', text: this.showLang[v]['views']['Video']['list_02_video']['part06'], start: 88},
              { time: '2:13', text: this.showLang[v]['views']['Video']['list_02_video']['part07'], start: 133},
              { time: '3:59', text: this.showLang[v]['views']['Video']['list_02_video']['part08'], start: 239},
            ]
          },
          {
            title: this.showLang[v]['views']['Video']['list_03_video']['title'],
            describe: this.showLang[v]['views']['Video']['list_03_video']['describe'],
            img: 'https://private.autoturn.net/img/youtube_03.png',
            src: 'https://youtu.be/6vD-2v5RWyk',
            playStatus: false,
            paragraph: [
              { time: '0:00', text: this.showLang[v]['views']['Video']['list_03_video']['part01'], start: 0},
              { time: '0:41', text: this.showLang[v]['views']['Video']['list_03_video']['part02'], start: 41},
              { time: '1:31', text: this.showLang[v]['views']['Video']['list_03_video']['part03'], start: 91},
              { time: '2:58', text: this.showLang[v]['views']['Video']['list_03_video']['part04'], start: 178},
              { time: '3:47', text: this.showLang[v]['views']['Video']['list_03_video']['part05'], start: 227},
              { time: '4:19', text: this.showLang[v]['views']['Video']['list_03_video']['part06'], start: 259},
            ]
          },
          {
            title: this.showLang[v]['views']['Video']['list_04_video']['title'],
            describe: this.showLang[v]['views']['Video']['list_04_video']['describe'],
            img: 'https://private.autoturn.net/img/youtube_04.png',
            src: 'https://youtu.be/3wGiBNSfa8E',
            playStatus: false,
            paragraph: [
              { time: '0:00', text: this.showLang[v]['views']['Video']['list_04_video']['part01'], start: 0},
              { time: '0:13', text: this.showLang[v]['views']['Video']['list_04_video']['part02'], start: 13},
              { time: '0:16', text: this.showLang[v]['views']['Video']['list_04_video']['part03'], start: 16},
              { time: '0:24', text: this.showLang[v]['views']['Video']['list_04_video']['part04'], start: 24},
              { time: '0:30', text: this.showLang[v]['views']['Video']['list_04_video']['part05'], start: 30},
              { time: '0:54', text: this.showLang[v]['views']['Video']['list_04_video']['part06'], start: 54},
              { time: '1:13', text: this.showLang[v]['views']['Video']['list_04_video']['part07'], start: 73},
              { time: '1:30', text: this.showLang[v]['views']['Video']['list_04_video']['part08'], start: 90},
              { time: '2:54', text: this.showLang[v]['views']['Video']['list_04_video']['part09'], start: 174},
              { time: '3:26', text: this.showLang[v]['views']['Video']['list_04_video']['part10'], start: 206},
              { time: '4:07', text: this.showLang[v]['views']['Video']['list_04_video']['part11'], start: 247},
            ]
          },
          {
            title: this.showLang[v]['views']['Video']['list_05_video']['title'],
            describe: this.showLang[v]['views']['Video']['list_05_video']['describe'],
            img: 'https://private.autoturn.net/img/youtube_05.png',
            src: 'https://youtu.be/L1VnIeaHB6o',
            playStatus: false,
            paragraph: [
              { time: '0:00', text: this.showLang[v]['views']['Video']['list_05_video']['part01'], start: 0},
              { time: '0:23', text: this.showLang[v]['views']['Video']['list_05_video']['part02'], start: 23},
            ]
          },
          {
            title: this.showLang[v]['views']['Video']['list_06_video']['title'],
            describe: this.showLang[v]['views']['Video']['list_06_video']['describe'],
            img: 'https://private.autoturn.net/img/youtube_06.png',
            src: 'https://youtu.be/ZVlnP5DHRkc',
            playStatus: false,
            paragraph: []
          },
          {
            title: this.showLang[v]['views']['Video']['list_07_video']['title'],
            describe: this.showLang[v]['views']['Video']['list_07_video']['describe'],
            img: 'https://private.autoturn.net/img/youtube_07.png',
            src: 'https://youtu.be/gugDShMcvk0',
            playStatus: false,
            paragraph: []
          },
          {
            title: this.showLang[v]['views']['Video']['list_08_video']['title'],
            describe: this.showLang[v]['views']['Video']['list_08_video']['describe'],
            img: 'https://private.autoturn.net/img/youtube_08.png',
            src: 'https://youtu.be/7heZPoatE-Q',
            playStatus: false,
            paragraph: []
          },
          {
            title: this.showLang[v]['views']['Video']['list_09_video']['title'],
            describe: this.showLang[v]['views']['Video']['list_09_video']['describe'],
            img: 'https://private.autoturn.net/img/youtube_09.png',
            src: 'https://youtu.be/ro54Sk19y4Y',
            playStatus: false,
            paragraph: []
          },
          {
            title: this.showLang[v]['views']['Video']['list_10_video']['title'],
            describe: this.showLang[v]['views']['Video']['list_10_video']['describe'],
            img: 'https://private.autoturn.net/img/youtube_10.png',
            src: 'https://youtu.be/si9M_0SU_fo',
            playStatus: false,
            paragraph: []
          },
          {
            title: this.showLang[v]['views']['Video']['list_11_video']['title'],
            describe: this.showLang[v]['views']['Video']['list_11_video']['describe'],
            img: 'https://private.autoturn.net/img/youtube_11.png',
            src: 'https://youtu.be/AAdlV078AM0',
            playStatus: false,
            paragraph: []
          },
          {
            title: this.showLang[v]['views']['Video']['list_12_video']['title'],
            describe: this.showLang[v]['views']['Video']['list_12_video']['describe'],
            img: 'https://private.autoturn.net/img/youtube_12.png',
            src: 'https://youtu.be/yzqTTtdVFcs',
            playStatus: false,
            paragraph: []
          },
          {
            title: this.showLang[v]['views']['Video']['list_13_video']['title'],
            describe: this.showLang[v]['views']['Video']['list_13_video']['describe'],
            img: 'https://private.autoturn.net/img/youtube_13.png',
            src: 'https://youtu.be/03BQP5UZqlI',
            playStatus: false,
            paragraph: []
          },
        ];
      },
      toParagraph(title, src, itmeSrc){
        // console.log('title');
        // console.log(title);
        // console.log('itmeSrc');
        // console.log(itmeSrc);
        // console.log('src');
        // console.log(src);
        // console.log('b this.vars.start');
        // console.log(this.vars.start);
        // this.videoData.title = title
        // this.videoData.src = src
        // this.videoData.itmeSrc = itmeSrc

        // if(src != '' && src != null && typeof src != 'undefined'){
        //   this.showVideoModal = true;
        // }

        this.defaultPlay = src
        this.vars.start = itmeSrc

        // console.log('a this.vars.start');
        // console.log(this.vars.start);

        this.$refs.youtube.seekTo(itmeSrc, true);
      },
      toVideo(title, src, paragraphList){
        // console.log('title');
        // console.log(title);
        // console.log('src');
        // console.log(src);
        // console.log('b this.vars.start');
        // console.log(this.vars.start);
        // console.log('b this.defaultParagraph');
        // console.log(this.defaultParagraph);
        // this.videoData.title = title
        // this.videoData.src = src
        // this.videoData.itmeSrc = itmeSrc

        // if(src != '' && src != null && typeof src != 'undefined'){
        //   this.showVideoModal = true;
        // }

        this.defaultPlay = src
        this.vars.start = 0
        this.defaultParagraph = paragraphList

        // console.log('a this.vars.start');
        // console.log(this.vars.start);
        // console.log('a this.defaultParagraph');
        // console.log(this.defaultParagraph);

        // this.$refs.youtube.seekTo(itmeSrc, true);

        // this.$refs.youtube.pauseVideo()
      },
      onReady() {
        // console.log('youtube');
        // this.$refs.youtube.playVideo()
        this.$refs.youtube.pauseVideo()
      },
    },
    mounted () {
      document.title = '教學影片 - AutoTurn';
    }
  }
</script>

<style scoped>
/* ─── VIDEO PAGE LAYOUT ─── */
.video-page {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.video-main {
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
  background: var(--ice, #f0f5fc);
}

.video-content {
  width: 92%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px 0;
}

.video-grid {
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 24px;
}

/* ─── PLAYER SECTION ─── */
.player-section {
  min-width: 0;
}

.player-card {
  background: var(--d2-white, #fff);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(15, 43, 74, 0.08);
}

.player-body {
  padding: 24px 28px;
}

/* ─── CHAPTERS ─── */
.chapters {
  padding-top: 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.chapter-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: var(--d2-blue, #2563eb);
  font-weight: 600;
  margin-bottom: 12px;
}

.chapter {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 14px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
}

.chapter:hover {
  background: var(--sky, #dbeafe);
}

.chapter-time {
  font-size: 13px;
  font-weight: 600;
  color: var(--d2-blue, #2563eb);
  background: rgba(37, 99, 235, 0.08);
  padding: 4px 10px;
  border-radius: 6px;
  min-width: 50px;
  text-align: center;
  flex-shrink: 0;
}

.chapter-text {
  font-size: 14px;
  color: var(--charcoal, #1e293b);
}

/* ─── LIST SECTION ─── */
.list-section {
  min-width: 0;
}

.list-scroll {
  max-height: calc(100vh - 160px);
  overflow-y: auto;
  padding-right: 4px;
}

.list-scroll::-webkit-scrollbar {
  width: 4px;
}

.list-scroll::-webkit-scrollbar-thumb {
  background: var(--d2-blue-light, #60a5fa);
  border-radius: 4px;
}

.list-scroll::-webkit-scrollbar-track {
  background: transparent;
}

/* ─── LIST CARD ─── */
.list-card {
  background: var(--d2-white, #fff);
  border-radius: 14px;
  margin-bottom: 8px;
  transition: all 0.25s ease;
  border: 1px solid transparent;
  overflow: hidden;
}

.list-card:hover {
  border-color: var(--d2-blue-light, #60a5fa);
  box-shadow: 0 2px 12px rgba(37, 99, 235, 0.1);
  transform: translateX(4px);
}

.list-card-inner {
  position: relative;
  display: flex;
  padding: 12px;
  gap: 12px;
}

.list-thumb-wrap {
  flex-shrink: 0;
  cursor: pointer;
}

.list-thumb-overlay {
  position: absolute;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 8px;
}

.list-thumb {
  width: 128px;
  height: 88px;
  border-radius: 8px;
  object-fit: cover;
}

.list-info {
  flex: 1;
  min-width: 0;
}

.list-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--charcoal, #1e293b);
  line-height: 1.4;
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.list-desc {
  font-size: 11px;
  color: var(--slate, #64748b);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0;
}

.list-play-btn {
  position: absolute;
  top: 40px;
  cursor: pointer;
  transition: all 0.5s;
}

/* ─── RESPONSIVE ─── */
@media (max-width: 768px) {
  .video-content {
    width: 100%;
    padding: 16px;
  }

  .video-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .list-scroll {
    max-height: none;
  }

  .player-body {
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .video-content {
    padding: 10px;
  }

  .list-thumb {
    width: 96px;
    height: 66px;
  }

  .list-card-inner {
    padding: 10px;
    gap: 10px;
  }

  .list-name {
    font-size: 12px;
  }

  .chapter {
    padding: 8px 10px;
    gap: 10px;
  }

  .chapter-time {
    font-size: 12px;
    min-width: 44px;
    padding: 3px 8px;
  }

  .chapter-text {
    font-size: 13px;
  }

  .player-body {
    padding: 12px;
  }
}
</style>